import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'



export interface StartupItemTypeStatTop5 {
  /** 启动项类型  1-启动菜单，2-计划任务，3-注册表启动软件，4-注册表启动服务' */
  autorun_type: number
  /** 该类型启动项数量 */
  count: number
}

export interface ActiveStartupTerminalTop5 {
  startup_item_name: number
  /** 该类型启动项数量 */
  startup_item_count: number
}

export interface itemStatResponseData {
  /** 启动项数量 */
  startup_item_count: number
  /** 已信任启动项数量 */
  trusted_startup_item_count: number
  /** 活跃启动终端TOP5列表 */
  active_startup_item_top5?: ActiveStartupTerminalTop5[]
  /** 启动项类型统计TOP5列表 */
  startup_item_type_stat_top5?: StartupItemTypeStatTop5[]
}
@Injectable()
export class BootOptimizeService {
  constructor (private http: Http) {
  }
  getTerminalStartupItemStat () {
    return this.http.post<itemStatResponseData>('/terminal/startup-item-stat', {})
  }
}
